import React, {Fragment, useEffect, useState} from 'react';
import {Section, Date_picker, Text, Select} from '../../../../components';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ScheduleIcon from '@material-ui/icons/Schedule';
import EmailIcon from '@material-ui/icons/Email';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import {Form, Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';


function Sequences(props){
  const[name_error, setNameError]=useState();
  const[description_error, setDescriptionError]=useState();
  const[html_template_error, setHtmlTemplateError]=useState();
  const[wait_error, setWaitError]=useState();
  const[type_error, setTypeError]=useState();

  function onSubmit(params){
    let err=false;
    for(let se of params.sequence_emails){
      if(se.html_template_id==undefined){err=true; setHtmlTemplateError('This field is required')}
      if(se.wait==undefined){err=true; setWaitError('This field is required')}
      if(se.type==undefined){err=true; setTypeError('This field is required')}
    }
    if(err==true || params.description==undefined || params.name==undefined || params.description=='' || params.name==''){
      if(params.description==undefined || params.description==''){setDescriptionError('This field is required');}
      if(params.name==undefined || params.name==''){setNameError('This field is required');}
    }else{
      if(props.match.params.id!=undefined){props.updateSequence(props.match.params.id, params);}
      else{props.createSequence(params);}
      props.history.push('/email/sequences')
    }
  }

  useEffect(()=>{
    if(props.templates==undefined){props.getTemplates();}
  },[]);

  let initial_values={}; if(props.match.params.id!=undefined && props.sequences!=undefined){initial_values=props.sequences[props.match.params.id];}
  let select_templates=[];

  if(props.templates!=undefined){for(let key in props.templates){if(props.templates[key].disabled!=true && (props.templates[key].workspace_share==true || props.templates[key].user_id==props.me.id)){select_templates.push({id:key, name:props.templates[key].name})}}}

  return(
    <Fragment>
    <Section title='New sequence' icon={<ScheduleIcon color='primary'/>} action={<Button variant='contained' onClick={()=>{props.history.push('/email/sequences')}}>Exit</Button>}>
      <Form
        onSubmit={onSubmit}
        mutators={{
          ...arrayMutators
        }}
        initialValues={initial_values}
      >
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
            <div style={{maxWidth:'400px', width:'100%'}}><Text required error={name_error} helperText={name_error} title='Name' name='name'/></div>
            <div style={{maxWidth:'400px', width:'100%'}}><Text required error={description_error} helperText={description_error} title='Description' name='description' rows={3}/></div>
            <FieldArray name='sequence_emails'>
            {({ fields }) =>
              <Fragment>
              <Typography color='primary' style={{marginTop:'30px', marginBottom:'30px'}}><span><EmailIcon color='primary' style={{position:'absolute', left:'20px'}}/></span><span style={{marginLeft:'40px'}}>Sequence steps</span><AddIcon color='secondary' style={{position:'absolute', right:'20px', cursor:'pointer'}} onClick={()=>{fields.push({}, undefined)}}/></Typography>
              {fields.map((name, index) => {
                return(
                  <Fragment>
                    <hr style={{width:'100%'}}/>
                    <Typography style={{marginLeft:'10px', marginBottom:'10px', position:'relative', width:'calc(100% - 20px)'}} color='primary'>{'Email '+(index+1)}<DeleteIcon color='secondary' style={{position:'absolute', right:'-10px', cursor:'pointer'}} onClick={()=>{fields.remove(index);}}/></Typography>
                    <Grid container style={{marginBottom:'20px'}}>
                    <Grid item xs={12} sm={6}>
                    <Grid container>
                      <Grid item xs={12} style={{marginBottom:'5px'}}><Text required error={wait_error} helperText={wait_error} erro type='number' title='Wait' name={`${name}.wait`}/></Grid>
                      <Grid item xs={12} style={{marginBottom:'10px'}}><Select required error={type_error} helperText={type_error} name={`${name}.type`} select_data={[{id:0, name:'Seconds'}, {id:1, name:'Minutes'}, {id:2, name:'Hours'}, {id:3, name:'Days'}, {id:4, name:'Weeks'}, {id:5, name:'Months'}]}/></Grid>
                      <Grid item xs={12} style={{marginBottom:'10px'}}>
                          <Typography color='primary' variant='caption' style={{paddingLeft:'10px'}}>Template</Typography>
                          <Select required error={html_template_error} helperText={html_template_error} name={`${name}.html_template_id`} select_data={select_templates}/>
                      </Grid>
                    </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {(props.templates==undefined)?null:
                        <Field name={`${name}.html_template_id`}>{(f)=>
                          <div style={{width:'calc(100% - 20px)', marginLeft:'10px', height:'100%', maxHeight:'170px', overflowX:'hidden', overflowY:'scroll'}}>
                            <div dangerouslySetInnerHTML={{ __html:(props.templates[f.input.value]==undefined)?null:props.templates[f.input.value].html}}></div>
                          </div>
                        }</Field>
                      }
                    </Grid>
                    </Grid>
                  </Fragment>
              )})}
              <div style={{marginTop:'30px', width:'100%', position:'relative', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{form_props.form.submit();}}>Save</Button></div>
              </Fragment>
            }</FieldArray>
          </form>
        )}
      </Form>
    </Section>
    <div style={{height:'30px'}}/>
    </Fragment>
  );
}


export default connect(ss, dd)(Sequences);

function ss(state){
  return{
    templates:state.templates.templates,
    sequences:state.templates.sequences
  }
}

function dd(dispatch){
  return{
    getTemplates:()=>{dispatch({type:'REQUEST_INDEX_HTML_TEMPLATES'})},
    createSequence:(data)=>{dispatch({type:'REQUEST_CREATE_EMAIL_SEQUENCE', payload:data})},
    updateSequence:(id, data)=>{dispatch({type:'REQUEST_UPDATE_EMAIL_SEQUENCE', id:id, payload:data})}
  }
}
